/******************************************************************
 * Archivo : client/src/mutations/toggleRole.js
 * Proyecto: CB30
 * Módulo  : Administración de Roles
 *
 * Propósito:
 * Activar o inactivar un Rol.
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  mutation ToggleRole($id: ID!) {

    toggleRole(id: $id) {

      id
      active

    }

  }
`;


// WEBPACK FOOTER //
// ./src/mutations/toggleRole.js